'use client';

import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

type VerticalCutRevealProps = {
  children: string;
  splitBy?: 'words' | 'chars';
  className?: string;
  staggerDuration?: number;
  staggerFrom?: 'first' | 'last';
};

export function VerticalCutReveal({
  children,
  splitBy = 'words',
  className,
  staggerDuration = 0.08,
  staggerFrom = 'first',
}: VerticalCutRevealProps) {
  const parts = splitBy === 'words' ? children.split(' ') : Array.from(children);

  return (
    <span className={cn('inline', className)} aria-label={children}>
      {parts.map((part, i) => {
        const delay =
          staggerFrom === 'first' ? i * staggerDuration : (parts.length - 1 - i) * staggerDuration;
        return (
          <motion.span
            key={`${part}-${i}`}
            className={cn(
              'inline-block overflow-hidden',
              splitBy === 'words' && i < parts.length - 1 && 'mr-[0.28em]',
            )}
            initial={{ y: '100%', opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              type: 'spring',
              stiffness: 260,
              damping: 28,
              delay,
            }}
          >
            {part}
          </motion.span>
        );
      })}
    </span>
  );
}
